<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M9.16,787.5l-8.66-5l-8.66,5v10l8.66,5l8.66-5V787.5z M8.52,787.87v9.26l-8.02,4.63l-8.02-4.63v-9.26l8.02-4.63L8.52,787.87
	z M-4.85,790.56h-0.83c0,0.43,0.16,0.77,0.47,1.02c0.31,0.25,0.74,0.37,1.28,0.37c0.53,0,0.94-0.13,1.23-0.38
	c0.29-0.25,0.44-0.57,0.44-0.95c0-0.37-0.12-0.65-0.37-0.85c-0.16-0.13-0.4-0.23-0.71-0.3l-0.72-0.17
	c-0.28-0.07-0.46-0.12-0.54-0.17c-0.13-0.07-0.2-0.18-0.2-0.33c0-0.16,0.07-0.29,0.2-0.38s0.31-0.14,0.54-0.14
	c0.2,0,0.37,0.04,0.5,0.1c0.2,0.11,0.31,0.28,0.33,0.53h0.84c-0.02-0.44-0.18-0.78-0.49-1.01c-0.31-0.23-0.68-0.35-1.12-0.35
	c-0.52,0-0.92,0.12-1.19,0.37c-0.27,0.25-0.41,0.56-0.41,0.93c0,0.41,0.14,0.71,0.42,0.9c0.17,0.12,0.46,0.22,0.9,0.32l0.44,0.1
	c0.26,0.06,0.45,0.12,0.57,0.19c0.12,0.08,0.18,0.18,0.18,0.32c0,0.24-0.12,0.4-0.36,0.48c-0.13,0.05-0.29,0.07-0.5,0.07
	c-0.34,0-0.58-0.08-0.73-0.26C-4.77,790.89-4.82,790.75-4.85,790.56L-4.85,790.56z M-1.69,791.84h0.86v-4.16h-0.86V791.84z
	 M-0.31,791.11v0.73h3.24v-0.73H0.74l2.18-2.73v-0.7h-3.18v0.74h2.09L-0.31,791.11L-0.31,791.11z M6.59,788.42v-0.74H3.54v4.16h3.15
	v-0.75h-2.3v-1.07H6.4v-0.72H4.38v-0.88H6.59L6.59,788.42z M-3.11,794.8h0.96v2.82h0.82v-4.09H-2c0,0.04-0.01,0.09-0.03,0.16
	c-0.04,0.12-0.09,0.22-0.16,0.29c-0.1,0.11-0.23,0.18-0.4,0.21c-0.1,0.02-0.28,0.04-0.53,0.05V794.8L-3.11,794.8z M-0.62,797.62
	h0.66l1.62-4.29H1L-0.62,797.62z M1.49,797.62h2.8v-0.71H2.5c0.05-0.08,0.11-0.16,0.19-0.22c0.07-0.06,0.21-0.17,0.41-0.31
	l0.32-0.23c0.27-0.19,0.47-0.37,0.58-0.52c0.18-0.23,0.27-0.5,0.27-0.81c0-0.39-0.13-0.71-0.38-0.95c-0.26-0.24-0.6-0.36-1.03-0.36
	c-0.55,0-0.93,0.2-1.14,0.61c-0.11,0.21-0.18,0.5-0.19,0.84h0.78c0.01-0.23,0.04-0.4,0.09-0.5c0.09-0.18,0.25-0.27,0.5-0.27
	c0.18,0,0.32,0.06,0.41,0.17c0.1,0.11,0.14,0.26,0.14,0.43c0,0.21-0.08,0.41-0.25,0.59c-0.11,0.11-0.35,0.3-0.72,0.57
	c-0.43,0.3-0.7,0.59-0.81,0.87C1.56,797.06,1.49,797.33,1.49,797.62L1.49,797.62z"/>
</svg>

</template>